
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airdrop/[type]",
      function () {
        return require("private-next-pages/airdrop/[type].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airdrop/[type]"])
      });
    }
  